// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Form Delete Confirmation Modal Styles */
.form-delete-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease-out;
}

.form-delete-modal-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  max-width: 520px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  animation: slideInScale 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
}

/* Header Section */
.form-delete-modal-header {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  border-bottom: 1px solid #f3f4f6;
  position: relative;
}

.form-delete-modal-icon {
  flex-shrink: 0;
  margin-top: 4px;
}

.form-delete-modal-title {
  flex: 1 1;
  min-width: 0;
}

.form-delete-modal-title h3 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.3;
}

.form-delete-modal-subtitle {
  margin: 0;
  font-size: 15px;
  color: #6b7280;
  font-weight: 400;
  line-height: 1.4;
}

.form-delete-close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-delete-close-btn:hover:not(:disabled) {
  background: rgba(75, 85, 99, 0.1);
  color: #374151;
}

.form-delete-close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Content Section */
.form-delete-modal-content {
  padding: 24px;
}

/* Warning Section */
.form-delete-warning {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  margin-bottom: 20px;
}

.form-delete-warning-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.form-delete-warning-content {
  flex: 1 1;
  min-width: 0;
}

.form-delete-warning-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #dc2626;
  line-height: 1.4;
}

.form-delete-warning-list {
  margin: 0;
  padding: 0 0 0 20px;
  list-style: none;
  position: relative;
}

.form-delete-warning-list li {
  margin: 0 0 6px 0;
  font-size: 13px;
  color: #dc2626;
  line-height: 1.4;
  position: relative;
  padding-left: 12px;
}

.form-delete-warning-list li:before {
  content: '•';
  position: absolute;
  left: 0;
  top: 0;
  color: #dc2626;
  font-weight: bold;
}

.form-delete-warning-list li:last-child {
  margin-bottom: 0;
}

/* Forms List Section */
.form-delete-list-container {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.form-delete-list-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f3f4f6;
  border-bottom: 1px solid #e5e7eb;
  font-size: 13px;
  font-weight: 600;
  color: #dc2626;
}

.form-delete-list {
  max-height: 180px;
  overflow-y: auto;
  padding: 8px 0;
}

.form-delete-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  transition: background-color 0.15s ease;
}

.form-delete-item:hover {
  background: #f3f4f6;
}

.form-delete-item-icon {
  flex-shrink: 0;
}

.form-delete-item-name {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.form-delete-item-status {
  flex-shrink: 0;
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
}

/* Footer Section */
.form-delete-modal-footer {
  padding: 20px 24px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.form-delete-cancel-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.form-delete-cancel-btn:hover:not(:disabled) {
  background: #e5e7eb;
  border-color: #9ca3af;
  transform: translateY(-1px);
}

.form-delete-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form-delete-confirm-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px 0 rgba(220, 38, 38, 0.3);
}

.form-delete-confirm-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px 0 rgba(220, 38, 38, 0.4);
}

.form-delete-confirm-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInScale {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes spinning {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spinning {
  animation: spinning 1s linear infinite;
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
  .form-delete-modal-container {
    background: #1f2937;
    border: 1px solid #374151;
  }
  
  .form-delete-modal-header {
    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
    border-bottom-color: #4b5563;
  }
  
  .form-delete-modal-title h3 {
    color: #f9fafb;
  }
  
  .form-delete-modal-subtitle {
    color: #d1d5db;
  }
  
  .form-delete-close-btn {
    color: #d1d5db;
  }
  
  .form-delete-close-btn:hover:not(:disabled) {
    background: rgba(209, 213, 219, 0.1);
    color: #f3f4f6;
  }
  
  .form-delete-warning {
    background: #431a1a;
    border-color: #7c2d12;
  }
  
  .form-delete-list-container {
    background: #374151;
    border-color: #4b5563;
  }
  
  .form-delete-list-header {
    background: #4b5563;
    border-bottom-color: #6b7280;
  }
  
  .form-delete-item:hover {
    background: #4b5563;
  }
  
  .form-delete-item-name {
    color: #e5e7eb;
  }
  
  .form-delete-item-status {
    color: #9ca3af;
  }
  
  .form-delete-modal-footer {
    background: #1f2937;
    border-top-color: #4b5563;
  }
  
  .form-delete-cancel-btn {
    background: #4b5563;
    color: #e5e7eb;
    border-color: #6b7280;
  }
  
  .form-delete-cancel-btn:hover:not(:disabled) {
    background: #6b7280;
    border-color: #9ca3af;
  }
}

/* Mobile Responsiveness */
@media (max-width: 640px) {
  .form-delete-modal-container {
    margin: 16px;
    width: calc(100% - 32px);
    border-radius: 12px;
  }
  
  .form-delete-modal-header {
    padding: 20px;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
  }
  
  .form-delete-close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
  }
  
  .form-delete-modal-content {
    padding: 20px;
  }
  
  .form-delete-modal-footer {
    padding: 16px 20px;
    flex-direction: column;
    gap: 8px;
  }
  
  .form-delete-cancel-btn,
  .form-delete-confirm-btn {
    width: 100%;
    justify-content: center;
  }
  
  .form-delete-modal-title h3 {
    font-size: 18px;
  }
  
  .form-delete-modal-subtitle {
    font-size: 14px;
  }
  
  .form-delete-list {
    max-height: 140px;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .form-delete-modal-overlay,
  .form-delete-modal-container,
  .form-delete-cancel-btn,
  .form-delete-confirm-btn {
    animation: none;
    transition: none;
  }
  
  .spinning {
    animation: none;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/FormDeleteConfirmModal.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,8DAA8D;EAC9D,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,6DAA6D;IAC7D,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Form Delete Confirmation Modal Styles */\n.form-delete-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.form-delete-modal-container {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  max-width: 520px;\n  width: 90%;\n  max-height: 90vh;\n  overflow: hidden;\n  animation: slideInScale 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  position: relative;\n}\n\n/* Header Section */\n.form-delete-modal-header {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  padding: 24px;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  border-bottom: 1px solid #f3f4f6;\n  position: relative;\n}\n\n.form-delete-modal-icon {\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n.form-delete-modal-title {\n  flex: 1;\n  min-width: 0;\n}\n\n.form-delete-modal-title h3 {\n  margin: 0 0 8px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  line-height: 1.3;\n}\n\n.form-delete-modal-subtitle {\n  margin: 0;\n  font-size: 15px;\n  color: #6b7280;\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n.form-delete-close-btn {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: none;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.form-delete-close-btn:hover:not(:disabled) {\n  background: rgba(75, 85, 99, 0.1);\n  color: #374151;\n}\n\n.form-delete-close-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Content Section */\n.form-delete-modal-content {\n  padding: 24px;\n}\n\n/* Warning Section */\n.form-delete-warning {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 12px;\n  margin-bottom: 20px;\n}\n\n.form-delete-warning-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.form-delete-warning-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.form-delete-warning-title {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #dc2626;\n  line-height: 1.4;\n}\n\n.form-delete-warning-list {\n  margin: 0;\n  padding: 0 0 0 20px;\n  list-style: none;\n  position: relative;\n}\n\n.form-delete-warning-list li {\n  margin: 0 0 6px 0;\n  font-size: 13px;\n  color: #dc2626;\n  line-height: 1.4;\n  position: relative;\n  padding-left: 12px;\n}\n\n.form-delete-warning-list li:before {\n  content: '•';\n  position: absolute;\n  left: 0;\n  top: 0;\n  color: #dc2626;\n  font-weight: bold;\n}\n\n.form-delete-warning-list li:last-child {\n  margin-bottom: 0;\n}\n\n/* Forms List Section */\n.form-delete-list-container {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.form-delete-list-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: #f3f4f6;\n  border-bottom: 1px solid #e5e7eb;\n  font-size: 13px;\n  font-weight: 600;\n  color: #dc2626;\n}\n\n.form-delete-list {\n  max-height: 180px;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n\n.form-delete-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px;\n  transition: background-color 0.15s ease;\n}\n\n.form-delete-item:hover {\n  background: #f3f4f6;\n}\n\n.form-delete-item-icon {\n  flex-shrink: 0;\n}\n\n.form-delete-item-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.form-delete-item-status {\n  flex-shrink: 0;\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 400;\n}\n\n/* Footer Section */\n.form-delete-modal-footer {\n  padding: 20px 24px;\n  background: #f9fafb;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.form-delete-cancel-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.form-delete-cancel-btn:hover:not(:disabled) {\n  background: #e5e7eb;\n  border-color: #9ca3af;\n  transform: translateY(-1px);\n}\n\n.form-delete-cancel-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.form-delete-confirm-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 14px 0 rgba(220, 38, 38, 0.3);\n}\n\n.form-delete-confirm-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px 0 rgba(220, 38, 38, 0.4);\n}\n\n.form-delete-confirm-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes spinning {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.spinning {\n  animation: spinning 1s linear infinite;\n}\n\n/* Dark Mode Support */\n@media (prefers-color-scheme: dark) {\n  .form-delete-modal-container {\n    background: #1f2937;\n    border: 1px solid #374151;\n  }\n  \n  .form-delete-modal-header {\n    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);\n    border-bottom-color: #4b5563;\n  }\n  \n  .form-delete-modal-title h3 {\n    color: #f9fafb;\n  }\n  \n  .form-delete-modal-subtitle {\n    color: #d1d5db;\n  }\n  \n  .form-delete-close-btn {\n    color: #d1d5db;\n  }\n  \n  .form-delete-close-btn:hover:not(:disabled) {\n    background: rgba(209, 213, 219, 0.1);\n    color: #f3f4f6;\n  }\n  \n  .form-delete-warning {\n    background: #431a1a;\n    border-color: #7c2d12;\n  }\n  \n  .form-delete-list-container {\n    background: #374151;\n    border-color: #4b5563;\n  }\n  \n  .form-delete-list-header {\n    background: #4b5563;\n    border-bottom-color: #6b7280;\n  }\n  \n  .form-delete-item:hover {\n    background: #4b5563;\n  }\n  \n  .form-delete-item-name {\n    color: #e5e7eb;\n  }\n  \n  .form-delete-item-status {\n    color: #9ca3af;\n  }\n  \n  .form-delete-modal-footer {\n    background: #1f2937;\n    border-top-color: #4b5563;\n  }\n  \n  .form-delete-cancel-btn {\n    background: #4b5563;\n    color: #e5e7eb;\n    border-color: #6b7280;\n  }\n  \n  .form-delete-cancel-btn:hover:not(:disabled) {\n    background: #6b7280;\n    border-color: #9ca3af;\n  }\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 640px) {\n  .form-delete-modal-container {\n    margin: 16px;\n    width: calc(100% - 32px);\n    border-radius: 12px;\n  }\n  \n  .form-delete-modal-header {\n    padding: 20px;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 12px;\n  }\n  \n  .form-delete-close-btn {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n  }\n  \n  .form-delete-modal-content {\n    padding: 20px;\n  }\n  \n  .form-delete-modal-footer {\n    padding: 16px 20px;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .form-delete-cancel-btn,\n  .form-delete-confirm-btn {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .form-delete-modal-title h3 {\n    font-size: 18px;\n  }\n  \n  .form-delete-modal-subtitle {\n    font-size: 14px;\n  }\n  \n  .form-delete-list {\n    max-height: 140px;\n  }\n}\n\n/* Reduced Motion */\n@media (prefers-reduced-motion: reduce) {\n  .form-delete-modal-overlay,\n  .form-delete-modal-container,\n  .form-delete-cancel-btn,\n  .form-delete-confirm-btn {\n    animation: none;\n    transition: none;\n  }\n  \n  .spinning {\n    animation: none;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
